<template>
  <div>
    <filtro-servico
      :filtro-inicial="mostrarSelecionados ? 2 : 1"
      @filtrado="filtraDadosTabela($event)"
    />
    <div>
      <vue-good-table
        ref="servicoTabela"
        :columns="colunas"
        :rows="valueAttr"
        :class="'tabela-servicos'"
        row-style-class="clickable"
        :search-options="{
          enabled: true,
          externalQuery: busca
        }"
        :select-options="{
          enabled: true,
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: true, // disable the select info panel on top
          selectAllByGroup: true,
          selectOnCheckboxOnly: true
        }"
        theme="view"
        @on-row-click="selecionaLinha"
        @on-select-all="selecionaTodos"
      >
        <!-- no records -->
        <div slot="emptystate">
          <p style="text-align:center; margin:0">
            Nenhum registro encontrado.
          </p>
        </div>
        <template
          slot="table-row"
          slot-scope="props"
        >
          <span v-if="props.column.useSlot">
            <slot
              name="customizado"
              :customizado="props"
            />
          </span>
          <span v-else-if="props.column.field == 'nome'">
            {{ props.row.nome }}
            <span :class="['servico-badge', {'badge badge-success':props.row.ativo, 'badge badge-danger': !props.row.ativo}]">
              {{ props.row.ativo ? 'Ativo' : 'Inativo' }}
            </span>
          </span>
          <span v-else-if="props.column.field == 'valorAuditar'">
            {{ parseFloat(props.row.valorAuditar.toFixed(2)).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency', minimumFractionDigits: 2 }) }}
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";

.view {
  .vgt-inner-wrap {
    box-shadow: none !important;
  }
}

.tabela-servicos {
  .vgt-left-align {
    pointer-events: none;
  }

  .vgt-right-align {
    pointer-events: none;
  }
}

.main-menu.menu-dark .navigation > li ul li > a {
  padding: 8px 10px 8px 12px;
}

.servico-badge {
  height: 1.2rem;
  font-size: 10px;
  font-weight: 600;
  border-radius: 2px;
  margin-left: 0.5rem;
}
</style>

<script>
import { VueGoodTable } from 'vue-good-table'

export default {
  name: 'TabelaServicos',
  components: {
    VueGoodTable,
    FiltroServico: () => import('@/app-modulo/comercial/pacote-servico/shared/components/tabela-servicos/filtro-servico/FiltroServico.vue'),
  },
  props: {
    colunas: {
      type: Array,
      required: true,
    },
    mostrarSelecionados: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => null,
    },
  },
  data() {
    return {
      value_: [],
      servicosBackupFiltro: null,
      busca: '',
      selecionados: [],
      filtro: {
        busca: '',
        filtroAtual: 0,
      },
    }
  },
  computed: {
    valueAttr: {
      set(value) {
        // eslint-disable-next-line no-underscore-dangle
        this.value_ = value
      },
      get() {
        // eslint-disable-next-line no-underscore-dangle
        return this.value_
      },
    },
  },
  created() {
    this.valueAttr = this.value
    if (this.mostrarSelecionados) {
      this.filtraDadosTabela({ filtroAtual: 2 })
    } else {
      this.filtraDadosTabela({ filtroAtual: 1 })
    }
  },
  methods: {
    getCode() {
      return Date.now().toString(36) + Math.random().toString(36).substring(2)
    },
    selecionaLinha(params) {
      if (!params.row.ativo && !params.row.vgtDisabled) {
        this.$set(params.row, 'vgtDisabled', true)
      }
      this.$set(params.row, 'selecionado', params.selected)
      this.$set(params.row, 'vgtSelected', params.selected)
      if (!params.row.code) {
        this.$set(params.row, 'code', this.getCode())
      }

      this.$emit('servico-selecionado', params.row)
    },
    selecionaTodos(params) {
      params.selectedRows.forEach(row => {
        if (row.vgtDisabled) {
          this.$set(row, 'selecionado', false)
          this.$set(row, 'vgtSelected', false)
        } else {
          this.$set(row, 'selecionado', true)
          this.$set(row, 'vgtSelected', true)
        }
        if (!row.code) {
          this.$set(row, 'code', this.getCode())
        }
      })

      this.valueAttr.forEach(servico => {
        if (servico.vgtDisabled) {
          this.$set(servico, 'selecionado', false)
          this.$set(servico, 'vgtSelected', false)
        } else {
          this.$set(servico, 'selecionadoAntes', true)
          this.$set(servico, 'selecionado', params.selected)
          this.$set(servico, 'vgtSelected', params.selected)
        }
        if (!servico.code) {
          this.$set(servico, 'code', this.getCode())
        }
      })

      this.$emit('todos-selecionado', params.selectedRows)
    },
    iniciarFiltro() {
      if (this.servicosBackupFiltro && this.servicosBackupFiltro.length > 0) {
        this.encerrarFiltro()
      }
      this.servicosBackupFiltro = [...this.valueAttr]
    },
    encerrarFiltro() {
      this.valueAttr = [...this.servicosBackupFiltro]
      this.servicosBackupFiltro = null
    },
    filtraDadosTabela(filtro) {
      if (filtro.busca && filtro.busca !== '') {
        if (this.servicosBackupFiltro === null) {
          this.servicosBackupFiltro = [...this.valueAttr]
        }
        this.filtro.busca = filtro.busca
        this.valueAttr = this.getPorBusca(filtro.busca)
      } else {
        if (this.filtro.busca !== '') {
          this.valueAttr = [...this.servicosBackupFiltro]
          this.servicosBackupFiltro = null
          this.filtro.busca = ''
        }

        this.iniciarFiltro()
        this.filtro.filtroAtual = filtro.filtroAtual

        if (filtro.filtroAtual === 1) {
          this.valueAttr = this.getPorAtivo(filtro.filtroAtual === 1)
        } else if (filtro.filtroAtual === 2) {
          this.valueAttr = this.getPorSelecionado(filtro.filtroAtual === 2)
        } else if (filtro.filtroAtual >= 4) {
          this.valueAttr = this.getPor([4, 5].includes(filtro.filtroAtual), [4].includes(filtro.filtroAtual))
        }
      }
    },
    getPor(ativo, selecionado) {
      // eslint-disable-next-line eqeqeq
      return this.valueAttr.filter(f => f.ativo === ativo
        && ((!selecionado && !f.vgtSelected)
          || (f.vgtSelected === selecionado)))
    },
    getPorAtivo(ativo) {
      return this.valueAttr.filter(f => f.ativo === ativo)
    },
    getPorSelecionado(selecionado) {
      return this.valueAttr.filter(f => {
        if (selecionado) return f.vgtSelected
        return !f.vgtSelected
      })
    },
    getPorBusca(busca) {
      this.valueAttr = [...this.servicosBackupFiltro]
      return this.valueAttr.filter(f => f.nome.toLowerCase().includes(busca.toLowerCase()))
    },
  },
}
</script>
